<!-- 地产和物业-认证列表 -->

<template>
  <div class="authentica-list-container main-cnt">
    <div class="title">认证列表</div>
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :ischeck="false" :filters="filters"
        :ispaging="true" :apiName="RealEstate.getRoomsLists" :columns="tableColumns" @onDetailsBtn="onDetailsBtn"
        @onGiftPoints="onGiftPoints" @companyChange="companyChange">
        <template #giftPoints="{ row }">
          <template v-if="row.sent_integration == 0 && authData.indexOf('s_e2299f8969e784853950daf7fd94') != -1">
            <el-button class="theme-font-btn" @click="onGiftPoints(row)">赠送积分</el-button>
          </template>
        </template>
      </common-table>
    </div>

    <!-- 会员房产 -->
    <w-dialog ref="dialogRoomRef" title="会员房产" width="55%" btnWidth="140px" top="20vh" :hideFooter="true">
      <w-title :title_name="'会员信息'"></w-title>
      <el-row :gutter="20" class="member-info">
        <el-col :span="8">
          <div class="flex">
            <div class="member-info-title">会员姓名</div>
            <div class="member-info-content">{{ infoDatas.m_realname }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="flex">
            <div class="member-info-title">会员账号</div>
            <div class="member-info-content">{{ infoDatas.m_mobile }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="flex">
            <div class="member-info-title">会员积分</div>
            <div class="member-info-content">{{ infoDatas.m_integration }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="flex s-m-t">
            <div class="member-info-title">会员性别</div>
            <div class="member-info-content">
              {{ infoDatas.m_sex == '1' ? '男' : infoDatas.m_sex == '2' ? '女' : '未知' }}
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="flex s-m-t">
            <div class="member-info-title">会员生日</div>
            <div class="member-info-content">{{ infoDatas.m_birth }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="flex s-m-t">
            <div class="member-info-title">会员等级</div>
            <div class="member-info-content">{{ infoDatas.m_level_label }}</div>
          </div>
        </el-col>
      </el-row>
      <div class="m-m-t">
        <common-table ref="tableRoomRef" tableHeight="350" :tableData="memberProperty" :columns="roomTableColumns"
          :ispaging="false" class="s-m-t">
          <template #is_deliver="{ row }">
            <div class="flex align-center">
              <div class="dots" :class="row.is_deliver == '是' ? 'bg-green' : 'bg-orange'"></div>
              <div>{{ row.is_deliver }}</div>
            </div>
          </template>
        </common-table>
      </div>
    </w-dialog>

    <!-- 详情 -->
    <AttestaDetails ref="refDetails" @closeLoading="closeLoading" @refreshLists="onRefreshLists"></AttestaDetails>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, } from "vue";
import { RealEstate, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";
import { useStore } from "vuex";
import AttestaDetails from "../components/AttestaDetails.vue";

// 权限
const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

onMounted(() => {
  tableRef.value.tableLoad();
  getSelectOption();
});

const filters = ref([
  {
    filterType: "search",
    name: "keywords",
    value: "",
    placeholder: "请输入房号",
  },
  {
    filterType: "select",
    name: "sp_cid",
    value: "",
    placeholder: "请选择公司",
    options: [],
    val: "sun_id",
    lab: "sun_name",
    action: "companyChange",
  },
  {
    filterType: "select",
    name: "mr_p_id",
    value: "",
    placeholder: "请选择项目",
    options: [],
    val: "sp_p_id",
    lab: "sp_p_name",
  },
]);
/** 表格对象 */
const tableRef = ref(null);

/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "mr_id",
    label: "ID",
  },
  {
    prop: "mr_roomnum",
    label: "认证房产",
  },
  {
    prop: "bind_room_num",
    label: "认证人数",
  },
  {
    prop: "sun_name",
    label: "公司名称",
  },
  {
    prop: "sp_p_name",
    label: "项目名称",
  },
  {
    prop: "sent_integration",
    label: "已送积分",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 200,
    bottons: [
      {
        name: "详情",
        action: "onDetailsBtn",
        className: "theme-font-btn",
        token: "s_d30b26547533277c18d8be7638e2",
      },
      {
        type: "customRender",
        name: "赠送积分",
        action: "giftPoints",
      },
    ],
  },
]);

const refDetails = ref(null);  // 详情对话框对象
/**
 * 
 * 详情按钮
 * 
 * **/
const onDetailsBtn = (row) => {
  tableRef.value.isLoading = true;
  refDetails.value.openDialog(row.mr_room_id, 'info');
}
/**
 * 
 * 赠送积分按钮
 * 
 * **/
const onGiftPoints = (row) => {
  tableRef.value.isLoading = true;
  refDetails.value.openDialog(row.mr_room_id, 'points');
}
/**
 * 
 * 关闭列表加载状态
 * 
 * **/
const closeLoading = () => {
  tableRef.value.isLoading = false;
}
const dialogRoomRef = ref(null);  // 会员房产
const infoDatas = ref('');  // 详情数据
const tableRoomRef = ref(null);  // 会员房产表格对象
const memberProperty = ref([]);  // 会员房产表格数据
/** 表格配置数据 */
const roomTableColumns = ref([
  {
    prop: "project_name",
    label: "项目",
    minWidth: 280,
  },
  {
    prop: "roomnum",
    label: "房号",
    minWidth: 100,
  },
  {
    prop: "buildareas",
    label: "面积",
  },
  {
    prop: "is_deliver",
    label: "是否交房",
    type: 'customRender',
  },
  {
    prop: "mr_create_time",
    label: "认证时间",
    minWidth: 140,
  },
  {
    prop: "type_text",
    label: "认证方式",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 100,
    bottons: [
      {
        name: "解绑",
        action: "onUnbindBtn",
        token: "m_mTtfimwfvB00YYHUuyeNNu8IS2",
        className: "error-font-btn",
      },
    ]
  }
]);

/**
 * 
 * 地产和物业公司下拉 公司 - 项目
 * 
 * **/
const getSelectOption = () => {
  RealEstate.getSelectOption({}).then((res) => {
    if (res.Code === 200) {
      filters.value[1].options = res.Data.list;
    } else {
      ElMessage.error(res.Message);
    }
  });
}
/**
 * 
 * 选择公司
 * 
 * **/
const companyChange = (data) => {
  filters.value[2].value = '';
  tableRef.value.tableLoad();
  if (data.value == '') {
    filters.value[2].options = [];
    return false;
  }
  let findData = data.options.find(item => item.sun_id == data.value);
  filters.value[2].options = findData.projects;
}
/**
 * 
 * 详情-赠送积分成功
 * 
 * **/
const onRefreshLists = () => {
  tableRef.value.tableLoad();
}

</script>
<style lang="scss">
.authentica-list-container {
  font-family: "Source Han Sans CN";

  .content {
    padding: 15px 20px 20px;
  }

  .member-info-title {
    color: #92979E;
    text-align: left;
    width: 80px;
  }

  .member-info-content {
    color: #262C30;
  }
}
</style>